import DownloadAppModal from './DownloadAppModal';

export default DownloadAppModal;
